import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { formatLongStr } from '../../../utils/format';
import { WalletAssetItem } from '../../../types/api';
import styles from './AssetsView.module.scss';

type Props = {
  list: WalletAssetItem[];
  loading: boolean;
}

const AssetsView: React.FC<Props> = ({ list, loading }) => {
  const { t } = useTranslation();
  const walletColumn: ColumnsType<WalletAssetItem> = [
    {
      title: t('address'),
      key: 'address',
      dataIndex: 'address',
      render: (val) => formatLongStr(val, '***', 10, 6),
    },
    {
      title: t('token'),
      key: 'token_name',
      dataIndex: 'token_name',
      render: (val, row) => (
        <div>
          <img className={styles.icon} src={row.icon} alt="" />
          <span className={styles.label}>{val}</span>
        </div>
      ),
    },
    {
      title: t('price'),
      key: 'usd_price',
      dataIndex: 'usd_price',
      render: (val) => `$${val}`,
    },
    {
      title: t('amount'),
      key: 'exact_amount',
      dataIndex: 'exact_amount',
    },
    {
      title: t('value'),
      key: 'usd',
      dataIndex: 'usd',
      render: (val) => `$${val}`,
    },
  ];
  return (
    <div className="g-card">
      <div className="g-table-wrapper">
        <Table
          loading={loading}
          rowKey={(record) => `${record.address}${record.token_name}`}
          columns={walletColumn}
          dataSource={list}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default AssetsView;
